import type { ColumnDef } from "@tanstack/react-table"
import { ExternalLinkIcon } from "lucide-react"
import { Link } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { FRONTEND_ROUTES } from "@/constants"
import { getStatusInfo } from "@/helpers"
import { formatMoney } from "@/helpers/format"
import { getRequestTypeInfo } from "@/helpers/sales"
import { DateHelper } from "@/utils"

import { AppBadge } from "../commons"
export const salesColumns: ColumnDef<TransactionType>[] = [
  {
    accessorKey: "orderCode",
    header: "Pedido",
    enableHiding: false,
    cell: ({ row }) => row.original.orderCode,
  },
  {
    accessorKey: "proposalNumber",
    header: "ID do cliente",
    cell: ({ row }) => row.original.proposalNumber,
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const { status } = row.original
      return <AppBadge getBadgeInfo={() => getStatusInfo(status)} />
    },
  },
  {
    accessorKey: "requestType",
    header: "Tipo de transação",
    cell: ({ row }) => {
      const { requestType } = row.original
      return <AppBadge getBadgeInfo={() => getRequestTypeInfo(requestType)} />
    },
  },
  {
    accessorKey: "installmentCount",
    header: "Parcelas",
    cell: ({ row }) => row.original.installmentCount,
  },
  {
    accessorKey: "orderDate",
    header: "Data do processamento",
    cell: ({ row }) =>
      DateHelper.formatDate(row.original.orderDate, "dd/MM/yyyy"),
  },
  {
    accessorKey: "orderValue",
    header: "Valor",
    cell: ({ row }) => formatMoney(row.original.orderValue / 100),
  },
  {
    accessorKey: "commissionValue",
    header: "Taxa",
    cell: ({ row }) => formatMoney(row.original.commissionValue / 100),
  },
  {
    accessorKey: "cashbackValue",
    header: "Cashback",
    cell: ({ row }) => formatMoney(row.original.cashbackValue / 100),
  },
  {
    accessorKey: "netValue",
    header: "Valor a receber",
    cell: ({ row }) => formatMoney(row.original.netValue / 100),
  },
  {
    accessorKey: "paymentMethod",
    header: "Método de pagamento",
    cell: ({ row }) => row.original.paymentMethod,
  },
  {
    accessorKey: "actions",
    header: "",
    enableHiding: false,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Button
          size="icon"
          variant="ghost"
          className="shadow-none"
          aria-label="Ver detalhes"
          asChild
        >
          <Link
            to={`${FRONTEND_ROUTES.SALES.href}/details/${row.original.id}`}
          >
            <ExternalLinkIcon size={16} strokeWidth={2} aria-hidden="true" />
            <span className="sr-only">Ver detalhes</span>
          </Link>
        </Button>
      </div>
    ),
  },
]
